// extracted by mini-css-extract-plugin
module.exports = {"newPost":"NewPost_newPost__cO7Tq","profilePicture":"NewPost_profilePicture__3W0Sg"};